interface CardProps {
	children: React.ReactNode;
	className?: string;
	variant?: "default" | "elevated" | "outlined";
}

const variantClasses: Record<string, string> = {
	default: "bg-bg-secondary",
	elevated: "bg-bg-elevated shadow-md",
	outlined: "bg-bg-secondary border border-border-default",
};

export function Card({ children, className = "", variant = "outlined" }: CardProps) {
	return <div className={`rounded-lg p-4 ${variantClasses[variant]} ${className}`}>{children}</div>;
}
